import { CSSProperties } from 'react';
import { InterpolationArguments } from 'react-i18next';
import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';
import { VerticalAlignment } from 'src/common/enumerations/verticalAlignment';
import { EmeraldDialogTypes } from '../../enumerations/emerald-dialog-types';

export enum MessageModalSizeEnum {
  Medium,
  Large,
  ExtraLarge,
  FullScreen,
}

export interface IMessageModal {
  type?: EmeraldDialogTypes;
  message?: string;
  subMessage?: string | JSX.Element[] | JSX.Element;
  subMessage2?: string;
  onAccept?: () => void;
  onCancel?: () => void;
  disableBackdropClick?: boolean;
  acceptButtonLabel?: string;
  closeButtonLabel?: string;
  buttonComponent?: JSX.Element;
  title?: string;
  size?: MessageModalSizeEnum;
  dialogStyle?: CSSProperties;
  subBarText?: string;
  separateButton?: boolean;
  textContent?: JSX.Element;
  verticalAlignment?: VerticalAlignment;
  showDialogBar?: boolean;
  modalId?: string;
  messageOverride?: string;
  messageArgs?: InterpolationArguments;
  subMessageOverride?: string;
  subMessageArgs?: InterpolationArguments;
  hideButtons?: boolean;
  hideCancelButton?: boolean;
  hideAcceptButton?: boolean;
  dialogWidth?: number;
  dialogHeight?: number;
  dialogTestIdPrefix?: string;
  header?: string;
  component?: JSX.Element;
  dialogContentComponent?: JSX.Element;
  dialogContentAboveSubMessage?: boolean;
  leftButtons?: NCRBaseButtonProps[];
  rightButtons?: NCRBaseButtonProps[];
  centerButtons?: NCRBaseButtonProps[];
  fullScreen?: boolean;
}
